import { type ReactNode } from 'react'

export type TMoreInfoValues = {
    title: string
    author: string
    duration: string
    bitrate: string
    date: string
}

/*
 * SEO "more info" paragraph, ported from audio-web `audio-more-info/strings`. nextjs interpolated
 * user-controlled title/author into an unescaped `dangerouslySetInnerHTML` template; returning nodes
 * lets the renderer escape them.
 *
 * The spans carry no emphasis on purpose: the reference marks them `font-semibold`, and its Tailwind
 * theme defines only normal/medium/bold, so that utility emits nothing and the values render at body
 * weight. Measured on both stands — the reference is 400 here.
 */
export const buildMoreInfoNodes = ({
    title,
    author,
    duration,
    bitrate,
    date,
}: TMoreInfoValues): ReactNode => (
    <>
        {'Listen to '}
        <span>{title}</span>
        {' by '}
        <span>{author}</span>
        {` MP3 song. ${title} song from ${author} is available on Audio.com. The duration of song is `}
        <span>{duration}</span>
        {'. This high-quality MP3 track has '}
        <span>{bitrate}</span>
        {' bitrate and was uploaded on '}
        <span>{date}</span>
        {`. Stream and download ${title} by ${author} for free on Audio.com – your ultimate destination for MP3 music.`}
    </>
)
